import { cn } from "@/lib/utils";

/** Small red counter badge used for unread messages. */
export function UnreadBadge({ count, className }: { count: number; className?: string }) {
  if (count <= 0) return null;
  return (
    <span
      className={cn(
        "inline-flex min-w-[1.15rem] items-center justify-center rounded-full bg-destructive px-1",
        "text-[10px] font-bold leading-[1.15rem] text-destructive-foreground",
        className,
      )}
    >
      {count > 9 ? "9+" : count}
    </span>
  );
}
